;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.common.services')
    .factory('HttpErrorInterceptor', HttpErrorInterceptor)

  /**
   *
   */
  HttpErrorInterceptor.$inject = ['$q', '$localStorage', '$rootScope']

  /**
   *
   */
  function HttpErrorInterceptor ($q, $localStorage, $rootScope) {
    return {
      /**
       *
       */
      request: function (config) {
        var canceler = $q.defer()

        config.timeout = canceler.promise

        if (!$localStorage.accessToken) {
          // Canceling request
          canceler.resolve()
        }

        return config || $q.when(config)
      },

      /**
       *
       */
      response: function (response) {
        return response
      },

      /**
       *
       */
      responseError: function (rejection) {
        console.info(rejection)

        rejection = checkConnectionStatus(rejection)

        return $q.reject(rejection)
      }
    }

    /**
     *
     */
    function checkConnectionStatus (rejection) {
      var data = {}

      // TODO: trouver une utilité aux codes d'erreur
      switch (rejection?.status) {
        case 401:
          data = {
            title: "Problème d'authentification au serveur.",
            message: 'Contacter un administrateur',
            status: rejection.status
          }
          break

        case 403:

          data = {
            title: 'Autorisation refusée', // NE PAS TOUCHER - TODO: Faire passer le code identification au rootScope pour analyse
            message: "Vous n'avez pas accès à cette partie de l'application.",
            status: rejection.status
          }
          // AuthService.authorize()
          break

        case 404:
          data = {
            title: "La ressource demandée n'a pas été trouvée.",
            message: "Vous avez tenté d'accéder à une ressource qui n'est plus ou pas disponible. Redémarrez votre recherche.",
            status: rejection.status
          }
          break

        case 503:
          data = {
            title: 'Le serveur a rencontré une erreur.',
            message: 'Nos serveurs ne sont pas disponibles, veuillez patienter quelques instants puis actualiser la page. Si le problème persiste, contacter un administrateur.',
            status: rejection.status
          }
          break

        default:
          data = {
            title: "Aucune connexion vers le serveur n'a pu être établie.",
            message: 'Vérifier la connexion internet puis actualiser la page. Si le problème persiste, contacter un administrateur.',
            status: rejection.status
          }
          break
      }

      /* data.title = 'La connexion vers le serveur n\'a pu être établie.'
       data.message = 'Vérifier la connexion internet plus actualiser la page. Si le problème persiste, contacter un administrateur.'
       */
      // if(rejection.status !== 500)
      if (rejection.xhrStatus !== 'timeout' && (!rejection?.config?.ignoreErrors || !_.includes(rejection?.config?.ignoreErrors, rejection?.status))) {
        // This way, when making specific requests, you can pass a $http config {ignoreErrors: [errorcodes]}
        $rootScope.$broadcast('httpNotResponding', data)
      }

      //
      return rejection
    }
  }
})(window.angular, window._)
